import React from 'react';

import { cn } from '@/lib/utils';

interface CreateWorkActivityStepsMobileProps {
  activeStep: number;
  className?: string;
}

const CreateWorkActivityStepsMobile: React.FC<CreateWorkActivityStepsMobileProps> = ({ activeStep, className }) => {
  const steps = [
    { number: 1, title: 'Activity' },
    { number: 2, title: 'Allocation' },
    { number: 3, title: 'Document' }
  ];

  return (
    <div className={cn('md:hidden flex items-center justify-between', className)}>
      {steps.map((step, index) => {
        const isActive = activeStep === step.number;
        const isCompleted = activeStep > step.number;
        const isLast = index === steps.length - 1;

        return (
          <div key={step.number} className="relative flex-1 flex flex-col justify-center items-center gap-2">
            <span
              className={cn(
                'z-[2] w-6 h-6 rounded-full flex items-center justify-center text-sm',
                isActive || isCompleted ? 'bg-primary text-white' : 'bg-white border border-primary text-primary'
              )}
            >
              {step.number}
            </span>
            <p className="text-sm">{step.title}</p>

            {/* Connecting line */}
            {!isLast && (
              <span
                className={cn(
                  'z-[0] absolute top-[12px] h-[2px]',
                  index === 0 ? 'left-[50%] w-1/2' : 'left-[0%] w-full',
                  isCompleted || (isActive && index === 0) ? 'bg-primary' : 'bg-primary'
                )}
              />
            )}
            {isLast && (
              <span
                className={cn(
                  'z-[0] absolute top-[12px] h-[2px]',
                  index === 0 ? 'left-[0%] w-1/2' : 'left-[0%] w-1/2',
                  isCompleted || (isActive && index === 0) ? 'bg-primary' : 'bg-primary'
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CreateWorkActivityStepsMobile;
